import Cookies from "js-cookie";

export class AuthHelper {
  static removeAllCookies = () => {
    for (const domain of [
      undefined,
      "localhost",
      "klap.app",
      ".klap.app",
      "new.klap.app",
    ]) {
      for (const samesite of ["strict", "lax", "none"]) {
        const options: Cookies.CookieAttributes = {
          path: "/",
          domain,
          sameSite: samesite as any,
          secure: true,
          expires: new Date(0),
        };
        Cookies.remove("sb-jcgvnoxzvxorflmpxjqv-auth-token", options);
        Cookies.remove("supabase-auth-token", options);
      }
    }

    // Best-effort clear of storage tokens used by Supabase clients
    try {
      const storages = [window.localStorage, window.sessionStorage];
      const shouldDelete = (k: string) => k == "sb-jcgvnoxzvxorflmpxjqv-auth-token"
        || k === "supabase.auth.token" || /^(sb-).*-auth-token$/.test(k);
      for (const storage of storages) {
        const keys = Object.keys(storage);
        for (const key of keys) if (shouldDelete(key)) storage.removeItem(key);
      }
    } catch (_) { }
  };
  static getAccessToken = (): string => {
    const cookieListString = Cookies.get("supabase-auth-token") || Cookies.get("sb-jcgvnoxzvxorflmpxjqv-auth-token");

    if (!cookieListString) {
      throw new Error("Unauthorized: Access token not found in cookies.");
    }

    let cookieList;
    try {
      cookieList = JSON.parse(cookieListString);
    } catch (error) {
      throw new Error("Error parsing cookie list.");
    }

    const accessToken = cookieList && cookieList[0];

    if (!accessToken) {
      throw new Error("Access token not found in cookie list.");
    }

    return accessToken as string;
  };
}
